<div class="title">
    <div>Registration</div>
    <button class="wiki-btn" (click)="goToWiki()">?</button>
</div>

<!-- TODO: Re-Enable choice when ICF backend is ready -->
<!--<cds-form-group layout="vertical" class="job-selection-dialog-content">
    <cds-radio-group>
        <label>Registration type</label>
        <cds-radio>
            <label>mIHC</label>
            <input
                type="radio"
                name="mihcRegistration"
                [(ngModel)]="selectedPipeline"
                [value]="PipelineTypeEnum.mIHC"
            />
        </cds-radio>
        <cds-radio>
            <label>cycIF</label>
            <input
                type="radio"
                name="cycifRegistration"
                [(ngModel)]="selectedPipeline"
                [value]="PipelineTypeEnum.cycIF"
            />
        </cds-radio>
    </cds-radio-group>
</cds-form-group>-->

<div class="job-selection-dialog-content">
    <ng-container *ngIf="selectedPipeline === PipelineTypeEnum.mIHC">
        <app-generic-registration-selection
            class="default-dialog-layout"
            [sourceLayers$]="mihcRegistrationSourceLayers$"
            [startJobFn]="startMihcRegistrationJobFn"
            [siblingDatasets]="siblingDatasets"
        ></app-generic-registration-selection>
    </ng-container>
    <ng-container *ngIf="selectedPipeline === PipelineTypeEnum.cycIF">
        <app-generic-registration-selection
            class="default-dialog-layout"
            [sourceLayers$]="cycifRegistrationSourceLayers$"
            [startJobFn]="startCycifRegistrationJobFn"
        ></app-generic-registration-selection>
    </ng-container>
</div>
